// @flow
import type { ThunkAction } from '../../core/types'
import type { Notification } from './types'
import { services } from '../../core/feathers'
import {
  startCommunication,
  endCommunication,
  isCommInProgress,
  getCommunicationState,
  COMM_STATES
} from '../../modules/communication/index'
import { batch } from '../../modules/lib/batchReducer'
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAIL,
  SAVE_NOTIFICATION,
  ALL_NOTIFICATIONS,
  DISMISS_NOTIFICATION_REQUEST,
  DISMISS_NOTIFICATION_SUCCESS,
  DISMISS_NOTIFICATION_FAIL,
  CLEAR_NOTIFICATIONS
} from './constants'
import { schemas, domains } from '../index'
import { normalize } from 'normalizr'
import {
  mergeEntities,
  removeOne,
  removeAll
} from '../../modules/entities/index'
import { lreplace, rpush, lrem } from '../../modules/list/actions'

// store a single notification
export function saveNotification(notification: Notification) {
  const { entities, result } = normalize(notification, schemas.notification)
  return batch(
    SAVE_NOTIFICATION,
    mergeEntities(entities),
    rpush(ALL_NOTIFICATIONS, result)
  )
}

// fetch all pending notifications and store them
export function fetchNotifications(): ThunkAction {
  return async function(dispatch, getState) {
    const resource = 'notifications'
    if (isCommInProgress(resource, getState())) {
      return
    }
    try {
      dispatch(batch(FETCH_NOTIFICATIONS_REQUEST, startCommunication(resource)))

      const data = await services.notifications.find()
      const { entities, result } = normalize(data, [schemas.notification])

      dispatch(
        batch(
          FETCH_NOTIFICATIONS_SUCCESS,
          mergeEntities(entities),
          lreplace(ALL_NOTIFICATIONS, result),
          endCommunication(resource)
        )
      )
    } catch (error) {
      console.warn('Error fetching notifications', error)
      dispatch(
        batch(FETCH_NOTIFICATIONS_FAIL, endCommunication(resource, false))
      )
    }
  }
}

// dismiss notification, marks as read in backend and removes from pending/current
export function dismissNotification(id: string): ThunkAction {
  return async function(dispatch, getState) {
    if (!id) return
    const resource = `notification:dismiss:${id}`
    if (getCommunicationState(resource, getState()) === COMM_STATES.Success) {
      return false
    }
    dispatch(batch(DISMISS_NOTIFICATION_REQUEST, startCommunication(resource)))
    try {
      await services.notifications.patch(id, {
        appSentAt: Date.now()
      })
      dispatch(
        batch(
          DISMISS_NOTIFICATION_SUCCESS,
          endCommunication(resource, true),
          lrem(ALL_NOTIFICATIONS, -1, id),
          removeOne(domains.NOTIFICATIONS, id)
        )
      )
      return true
    } catch (error) {
      console.warn('Error dismissing notification', error)
      dispatch(
        batch(DISMISS_NOTIFICATION_FAIL, endCommunication(resource, false))
      )
    }
  }
}

export function clearNotifications() {
  return batch(
    CLEAR_NOTIFICATIONS,
    lreplace(ALL_NOTIFICATIONS, []),
    removeAll(domains.NOTIFICATIONS)
  )
}



// WEBPACK FOOTER //
// ./src/services/notification/actions.js